var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "22px",
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    transform: "translate(-1324.000000, -184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(1325.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,8 L7,8 C7.55228475,8 8,8.44771525 8,9 L8,13 C8,13.5522847 7.55228475,14 7,14 L3,14 C2.44771525,14 2,13.5522847 2,13 L2,9 C2,8.44771525 2.44771525,8 3,8 Z",
    id: "Rectangle",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11 C0.018343099,11 7.0183431,11 21,11",
    id: "Path-20",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,16 L18,16 C18.5522847,16 19,16.4477153 19,17 L19,21 C19,21.5522847 18.5522847,22 18,22 L14,22 C13.4477153,22 13,21.5522847 13,21 L13,17 C13,16.4477153 13.4477153,16 14,16 Z",
    id: "Rectangle",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,19 C0.018343099,19 7.0183431,19 21,19",
    id: "Path-20",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,0 L18,0 C18.5522847,-1.01453063e-16 19,0.44771525 19,1 L19,5 C19,5.55228475 18.5522847,6 18,6 L14,6 C13.4477153,6 13,5.55228475 13,5 L13,1 C13,0.44771525 13.4477153,1.01453063e-16 14,0 Z",
    id: "Rectangle",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,3 C0.018343099,3 7.0183431,3 21,3",
    id: "Path-20",
    stroke: "#616161",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/Settings-icon.ba9dac973a903a2762384fc8db00d87a.svg";
export { ForwardRef as ReactComponent };